import { useEffect, useMemo, useRef } from 'react';
import { io } from 'socket.io-client';
import { host } from '../routes/apiRoutes';

export default function useSocketUserNotifications(userId, events = {}, deps = []) {
  const socketRef = useRef(null);

  // Compute base socket URL
  const baseUrl = useMemo(() => {
    const fromEnv = process.env.REACT_APP_SOCKET_URL;
    // same url for socket removing api and vi1
    const fallback = host.replace(/\/api\/v1$/, '');
    return fromEnv || fallback;
  }, []);

  useEffect(() => {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

    // Only connect if the user is logged in
    if (!token) {
      console.log('[Socket] No token found — skipping connection.');
      // If socket was connected before, disconnect it
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      return;
    }

    // Avoid multiple connections
  if (socketRef.current && socketRef.current.connected) return;
  const socket = io(baseUrl, {
    transports: ['websocket'], // force websocket only
    secure: true, // required for https
    withCredentials: false,
    auth: { token },
    reconnection: true,
    reconnectionAttempts: 3,
    reconnectionDelay: 1000,
  });
    socketRef.current = socket;

    socket.on('connect_error', (err) => {
      console.error('[Socket] Connection error:', err.message, "err", err);
    });

    // Attach event handlers
    Object.entries(events).forEach(([eventName, handler]) => {
      if (typeof handler === 'function') socket.on(eventName, handler);
    });

    // Cleanup when unmounting or when token changes
    return () => {
      if (socketRef.current) {
        Object.entries(events).forEach(([eventName, handler]) => {
          if (typeof handler === 'function') socketRef.current.off(eventName, handler);
        });
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [baseUrl, userId, ...deps]);

  return socketRef.current;
}
